<script lang="ts" setup>
interface Props {
  focus?: boolean
}

interface Emits {
  (event: 'submit', value: string | undefined): void
}

const props = defineProps<Props>()
const emit = defineEmits<Emits>()

const input = useTemplateRef<HTMLInputElement>('search-input')
const query = ref<string>()

const submit = (): void => {
  emit('submit', query.value)
  query.value = ''
}

watch(
  () => props.focus,
  (newValue: boolean) => {
    if (!newValue) {
      return
    }

    input.value?.focus()
  })
</script>

<template>
  <div>
    <form
      role="search"
      class="search-form"
      @submit.prevent="submit()"
    >
      <label
        for="headerSearch"
        class="sr-only search-form__label"
      >
        Search
      </label>
      <input
        ref="search-input"
        v-model="query"
        aria-label="search"
        type="search"
        name="headerSearch"
        placeholder="Search..."
        class="search-form__input"
      >
      <UIButton
        variant="clear"
        appended-icon="tabler:search"
        is-label-hidden
        type="submit"
        class="search-form__button"
      >
        Open Header Search
      </UIButton>
    </form>
  </div>
</template>

<style lang="scss" scoped>
.search-form {
  @apply flex items-center gap-[10px] px-[20px] py-[10px];
  @apply md:p-0;

  &__label {
    @apply text-white bg-primary;
  }

  &__input {
    @apply text-white bg-transparent w-auto grow py-[5px] px-[10px];
    @apply md:w-[250px] md:grow-0;
  }

  &__button {
    @apply text-[14px] text-white font-medium inline-flex items-center leading-[1] relative uppercase transition-colors duration-300;
    @apply before:content-[''] before:w-0 before:h-[2px] before:bg-white before:block before:transition-[width] before:duration-300 before:absolute before:-bottom-[4px] before:left-[22px];
    @apply hover:before:w-[calc(100%-22px)];

    :deep(.button__icon) {
      @apply w-[20px] h-[20px] mr-[6px] text-white/60;
    }
  }
}
</style>
